import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Gộp class Tailwind, class sau thắng class trước khi cùng nhóm thuộc tính.
 *
 * `clsx` lo phần điều kiện, `twMerge` lo phần xung đột: `cn('p-2', 'p-4')` ra
 * `p-4` chứ không phải cả hai — nếu không thì thứ tự trong file CSS quyết định
 * và kết quả phụ thuộc vào việc Tailwind sắp lớp nào trước.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
